export default {
  ACQUIRE: 'acquire',
  CREDIT: 'credit',
  GMB_REVIEWS: 'gmbReviews',
  INSURANCE: 'insurance',
  REVIEWS: 'reviews',
  SPOTLIGHT: 'spotlight',
  TEST_DRIVE: 'testDrive',
  TRADE: 'trade',
  SPIN: 'spin',
  ECOMV2: 'ecomV2',
  BUILD_AND_PRICE: 'buildAndPrice',
};
